<template>
  <ancestryline-modal title="forms.public-client.modal-responsible.title" id="modal-responsible-public-client-form" :close="false" :closeable="false" :loading="false">
    <form @submit.prevent="save">
      <card class="p-col-12" >
          <coff-input-select v-model="responsible" label="forms.public-client.modal-responsible.responsible" class="p-col-12" :options="clients"/>
      </card>

    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.cancel')" @click.prevent="close" type="button" class="p-mt-2 p-ml-auto p-button-outlined p-button-secondary"/>
        <Button :label="$t('btn.choose')" @click.prevent="save" style="float: right;margin-top: 8px;"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalGetResponsible",

  props: {
      clients: {type: Array, default: () => {return []}},
  },

  data(){
    return{
      responsible: null,
    }
  },

  methods:{

    close(){
      DialogService.closeModal(this.responsible);
    },

    save(){
      DialogService.closeModal(this.responsible);
    },

  },

}
</script>

<style scoped>

</style>